// extracted by mini-css-extract-plugin
module.exports = {"container":"_0f9e288","head":"_87eb46f","sortedHead":"_210c032","arrow":"_606a2a5","upwardsArrow":"_0dc9259","row":"_7d955d5","resizer":"_8e84b17"};